module.exports = __webpack_public_path__ + "img/jad-free.cf3a12e5.svg";